import { GrantTypes } from '../../../api/configurations/oauth2/types';

export const DefaultGrandType = [
  GrantTypes.password,
  GrantTypes.authorization_code,
  GrantTypes.refresh_token
];

export const grantTypes = (isServer: boolean, grants?: GrantTypes[]): GrantTypes[] => {
  if (isServer) {
    return [GrantTypes.client_credentials];
  }

  if (!grants || (Array.isArray(grants) && grants.length === 0)) {
    return DefaultGrandType;
  }

  return grants;
};
